import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './SalesEntry.css';

export default function SalesEntry() {
  return <Container className="border  container-sales-entry"></Container>;
}
